import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';

export const Container = styled.div`
  display: grid;
  margin: auto;
`;

export const GridBottomContainer = styled.div`
  display: flex;
  gap: 50px;
  flex-direction: column;
`;

export const GridTopContainer = styled.div`
  display: flex;
  gap: 50px;
  flex-direction: column;
  max-width: 600px;
  margin: auto;
`;

export const GridImageContainer = styled.div<{ $gridSize?: string }>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-items: center;
  row-gap: ${space('x8')};
  column-gap: ${space('xl')};

  margin: auto;

  @media screen and (${query.atLeast('tablet')}) {
    max-width: none;
    margin: unset;
    margin-top: ${space('x8')};
    row-gap: ${space('x10')};
    column-gap: 0;
    grid-template-columns: ${({ $gridSize }) => ($gridSize ? $gridSize : 'repeat(3, 1fr)')};
  }
`;

export const IndividualContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  div:first-child {
    span {
      width: 128px;
      height: 128px;
    }
  }

  img {
    border: 9px solid transparent;
    box-shadow: 0 0 0 1px #d4d4d4;
  }
`;

export const ContentContainer = styled.div<{ $reverse?: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  grid-row: 2;
  text-align: center;

  @media screen and (${query.atLeast('tablet')}) {
    margin-top: 0;
    grid-row: ${({ $reverse }) => ($reverse ? 1 : 'unset')};
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Eyebrow = styled.h3`
  text-transform: capitalize;
  ${font('subhead-md')};
  padding-bottom: ${space('lg')};

  @media screen and (${query.atLeast('tablet')}) {
    margin-top: ${space('lg')};
    padding-bottom: ${space('xs')};
  }
`;

export const Body = styled.h4`
  ${font('body-sm-light')};
  color: ${color('gray5')};
  line-height: 1.55;
  text-transform: capitalize;
  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md-light')};
  }
`;

export const Header = styled.h2`
  ${font('headline-xs')};
  padding: 0;

  @media screen and (${query.atLeast('tablet')}) {
    ${font('headline-md')};
  }
`;

export const Text = styled.div`
  color: ${color('fg')};
  padding-bottom: 42px;
  ${font('body-md-light')};
`;

export const StyledSpan = styled.span`
  ${font('headline-xs')};
  color: ${color('cta')};
  margin-right: 9px;
  position: relative;
  bottom: 1px;
  cursor: pointer;
`;

export const ImageWrapper = styled.div`
  background: #fff;
  border: 1px solid #969696;
  width: 103px;
  height: 103px;
  padding: 5px;
  border-radius: 65px;
  margin: 7px;
`;
export const ImageBox = styled.div`
  background: #969696;
  display: block;
  width: 102px;
  height: 102px;
  border-radius: 65px;
`;
